export default [
    {
        path: '/vip',
        name: '积分兑换',
        component: () => import(/* webpackChunkName: "integral" */ '../components/vip/Integral.vue')
    }, {
        path: '/vip/prize',
        name: '会员奖品',
        component: () => import(/* webpackChunkName: "prize" */ '../components/vip/Prize.vue')
    }, {
        path: '/vip/query',
        name: '积分查询',
        component: () => import(/* webpackChunkName: "queryintegral" */ '../components/vip/QueryIntegral.vue')
    }, {
        path: '/vip/benefits',
        name: '会员权益',
        component: () => import(/* webpackChunkName: "benefits" */ '../components/vip/Benefits.vue')
    }
]
